module.exports = __webpack_public_path__ + "img/Bent Prong.da813209.png";